const BASE_URL = process.env.REACT_APP_SIMULATION_API_URL || 'http://localhost:3000';

export async function createSimulation(payload, token, userId) {
  const res = await fetch(`${BASE_URL}/simulations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token  ? { Authorization: `Bearer ${token}` } : {}),
      ...(userId ? { 'x-user-id': userId } : {}),
    },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Simulation failed');
  return json.data;
}

// Public, unauthenticated, capped — powers the free /3d-cargo-load-simulator
// page. No token/userId — this is intentionally anonymous.
export async function createPublicSimulation(payload) {
  const res = await fetch(`${BASE_URL}/simulations/public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Simulation failed');
  return json.data;
}

export async function getSimulation(id, token, userId) {
  const res = await fetch(`${BASE_URL}/simulations/${id}`, {
    headers: {
      ...(token  ? { Authorization: `Bearer ${token}` } : {}),
      ...(userId ? { 'x-user-id': userId } : {}),
    },
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Could not load simulation');
  return json.data;
}
